<div class="modal-header border-0">
  <div class="position-relative text-center">
    <div class="form-back-btn-chevron"
         *ngIf="!requestSuccess"
         (click)="onBack.emit(); onFormChange.emit(AUTH_FORMS.LOGIN)">
      <i class="icon-chevron-left"></i>
    </div>
    <span class="font-xl fw-bold uppercase"
          [translate]="'modal.lostPassword.header'">Lost Password</span>
  </div>
</div>
<div class="modal-body">
  <ui-message class="d-block mt-1 mb-4"
              *ngIf="requestSuccess"
              [type]="'success'">
    <span [translate]="'modal.lostPassword.requestReceivedCheckYourEmail'">
      We have received your request to reset your password, please check your email!
    </span>
  </ui-message>

  <div class="mb-2"
       *ngIf="!requestSuccess">
    <div [translate]="'modal.lostPassword.ifForgotPasswordWeCanGenerateNew'">
      Hvis du har glemt ditt passord,kan vi generere et nytt til deg. Oppgi din registerte e-postadresse så sender vi et
      midlertidig passord til deg på e-post.
    </div>

    <div class="mt-4">
      <form #lostPasswordForm="ngForm">
        <label class="font-xl fw-bold"
               [translate]="'modal.lostPassword.emailAddress'">E-mail address</label>
        <input class="form-control"
               type="email"
               name="email"
               [placeholder]="'modal.lostPassword.emailAddress' | translate"
               required
               [pattern]="EMAIL_PATTERN"
               [(ngModel)]="email">
      </form>

      <div class="mt-4 text-end">
        <button class="btn btn-pink"
                [translate]="'common.send'"
                [disabled]="!lostPasswordForm.valid"
                (click)="onSubmit.emit(email)">
          Send
        </button>
      </div>
    </div>

    <ui-message class="d-block mt-4"
                *ngIf="error"
                [type]="'error'">
        {{error}}&nbsp;<span class="text-primary pointer"
           (click)="onCreateNewAccount.emit(); onFormChange.emit(AUTH_FORMS.REGISTER);"
           [translate]="'modal.lostPassword.createAccountLinkInErrorMsg'">Create a new account
      </span>
    </ui-message>
  </div>
</div>

